export default {
    scrolled(state){
        return state.scrolled;
    },
    storeActiveGroup(state){
        return state.storeActiveGroup;
    },
};
